import React, { useState, createContext } from "react";

export const UIContext = createContext();

export const UIProvider = props => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isTouchScreen, setIsTouchScreen] = useState(
    "ontouchstart" in document.documentElement
  );
  const [flowState, setFlowState] = useState(1);

  const setModalState = state => setFlowState(state);

  return (
    <UIContext.Provider
      value={{
        flowState,
        isDrawerOpen,
        isTouchScreen,
        setIsDrawerOpen,
        setIsTouchScreen,
        setModalState
      }}
    >
      {props.children}
    </UIContext.Provider>
  );
};
